// client/src/routes/app/properties/$propertyId/rent/payments.tsx — SCR-PROP-003 tab „Chirii și
// încasări", its payments view (D-2840).
//
// SCR-RENT-003's list with the property pinned: every payment received for the apartment. It
// sits under the rent tab rather than beside it, as `/app/rent/payments` sits under the board,
// so the tab stays lit while it is open. `Payments.Read`, as the list's own route.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { PaymentsList } from '@/features/payments/PaymentsList';
import { paymentSearchSchema, type PaymentSearch } from '@/features/payments/search';

export const Route = createFileRoute('/app/properties/$propertyId/rent/payments')({
  validateSearch: paymentSearchSchema,
  component: PaymentsListTab,
});

function PaymentsListTab() {
  const { propertyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Payments.Read">
      <PaymentsList
        pinnedPropertyId={propertyId}
        search={search}
        onSearchChange={(next: (previous: PaymentSearch) => PaymentSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
